import React, { useEffect, useState } from 'react';
import useTheme from "@mui/material/styles/useTheme";
import useMediaQuery from '@mui/material/useMediaQuery';
import { useStyles } from "../styles/styles";
import { getDecimal } from "../global/utils";
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import ArrowBackIosNewRoundedIcon from "@mui/icons-material/ArrowBackIosNewRounded";
import ReplayIcon from '@mui/icons-material/Replay';
import PaymentsTwoToneIcon from "@mui/icons-material/PaymentsTwoTone";
import { IconButton, Card } from "@mui/material";
import {DeleteTwoTone} from "@mui/icons-material";

const SelectedFees = (props) => {
    const fees = props.fees;
    const feeTotal = props.feeTotal;
    const processingFee = props.processingFee;
    const splitFees = props.splitFees;
    const removeSelected = props.removeSelected;
    const clearSelected = props.clearSelected;
    const selectedOption = props.selectedOption;
    const setShowSelected = props.setShowSelected;
    const payClicked = props.payClicked;
    const classes = useStyles;
    const [totalAmount, setTotalAmount] = useState(0);
    const theme = useTheme();
    const smallScreen = useMediaQuery(theme.breakpoints.down('sm'));

    useEffect(() => {
        let total = 0;
        if (feeTotal) total += feeTotal;
        if (processingFee) total += processingFee;
        total = parseFloat(getDecimal(total, false));
        setTotalAmount(total);
    }, [feeTotal, processingFee]);

    return (
        <>
            {!smallScreen && (
                <Paper elevation={3} sx={{ ...classes.listContainer, maxHeight: '85vh', overflow: 'auto' }}>
                    <Typography
                        variant='h6'
                        component='h3'
                        color='primary'
                        sx={{ fontSize: '1.2rem', marginTop: 1 }}
                    >
                        Selected Fees
                    </Typography>
                    <List sx={classes.list}>
                        <ListItem alignItems="flex-start" sx={classes.listPadding}>
                            <ListItemText
                                sx={classes.listText}
                                primary={
                                    <Grid container spacing={1} style={{ width: '100%' }}>
                                        <Grid item xs={5} md={4}>Fee Name</Grid>
                                        <Grid item xs={6} md={2} style={classes.valueRight}>Item Amt.</Grid>
                                        <Grid item xs={5} md={2} style={classes.valueRight}>Qty.</Grid>
                                        <Grid item xs={5} md={3} style={{ ...classes.valueRight }}>Amount</Grid>
                                        <Grid item xs={1}>&nbsp;</Grid>
                                    </Grid>
                                }
                                primaryTypographyProps={{
                                    component: 'span',
                                    variant: 'subtitle1',
                                    sx: classes.inline,
                                    color: 'primary',
                                }}
                            />
                        </ListItem>
                        {fees && fees.map((fee) => (
                            <ListItem
                                alignItems="flex-start"
                                divider
                                sx={classes.listPadding}
                                key={fee.key}
                            >
                                <ListItemText
                                    sx={classes.listText}
                                    primary={
                                        <Grid container spacing={1} style={{ width: '100%' }}>
                                            <Grid item xs={5} md={4}>{fee.name}</Grid>
                                            <Grid item xs={6} md={2} style={classes.valueRight}>
                                                {getDecimal(fee.itemAmount)}
                                            </Grid>
                                            <Grid item xs={5} md={2} style={classes.valueRight}>
                                                {Math.floor(fee.quantity)}
                                            </Grid>
                                            <Grid item xs={5} md={3} style={classes.valueRight}>
                                                {getDecimal(fee.amount)}
                                            </Grid>
                                            <Grid
                                                item
                                                xs={1}
                                                container
                                                direction="row"
                                                justifyContent="flex-end"
                                            >
                                                <Button
                                                    variant="contained"
                                                    color="error"
                                                    onClick={() => removeSelected(fee.key)}
                                                    sx={classes.tinyButton}
                                                >
                                                    Delete
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    }
                                    secondary={
                                        fee.comments && (
                                            <Grid container style={{ width: '100%' }}>
                                                <Grid item xs={12} sm={3}>
                                                    <Typography variant="subtitle2" color="secondary">
                                                        Comments:
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={12} sm={9}>
                                                    <Typography variant="body2" color="textPrimary">
                                                        {fee.comments}
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                        )
                                    }
                                    primaryTypographyProps={{
                                        component: 'span',
                                        variant: 'body2',
                                        sx: classes.inline,
                                        color: 'textPrimary',
                                    }}
                                />
                            </ListItem>
                        ))}
                        {selectedOption && (
                            <ListItem alignItems="flex-start" divider sx={classes.listPadding}>
                                <ListItemText
                                    sx={classes.listText}
                                    primary={
                                        <Grid container spacing={1} style={{ width: '100%' }}>
                                            <Grid item xs={6} md={4}>{selectedOption.name}</Grid>
                                            <Grid item xs={6} md={4}>
                                                Description: {selectedOption.description}
                                            </Grid>
                                            <Grid item xs={6} md={3} style={classes.valueRight}>
                                                {getDecimal(selectedOption.amount)}
                                            </Grid>
                                            <Grid item xs={1}>&nbsp;</Grid>
                                        </Grid>
                                    }
                                    primaryTypographyProps={{
                                        component: 'span',
                                        variant: 'body2',
                                        sx: classes.inline,
                                        color: 'textPrimary',
                                    }}
                                />
                            </ListItem>
                        )}
                        <ListItem alignItems="flex-start" sx={classes.listPadding}>
                            <ListItemText
                                sx={classes.listText}
                                primary={
                                    <Grid container spacing={1} style={{ width: '100%' }}>
                                        <Grid
                                            item
                                            xs={10}
                                            sm={4}
                                            sx={{ ...classes.valueRight, fontWeight: 'medium' }}
                                        >
                                            {`Fee Total: ${getDecimal(feeTotal)}`}
                                        </Grid>
                                        {splitFees ? (
                                            <Grid item xs={11} md={6}>
                                                We cannot determine the amount of the Processing Fee until you select a payment type. Depending upon the type of payment you select, you may be required to pay a Processing Fee to process the transaction.
                                            </Grid>
                                        ) : (
                                            <>
                                                <Grid
                                                    item
                                                    xs={10}
                                                    sm={4}
                                                    sx={{ ...classes.valueRight, fontWeight: 'medium' }}
                                                >
                                                    {`Processing Fee: ${getDecimal(processingFee)}`}
                                                </Grid>
                                                <Grid
                                                    item
                                                    xs={10}
                                                    sm={4}
                                                    sx={{ ...classes.valueRight, fontWeight: 'medium' }}
                                                >
                                                    {`Total Amount: ${getDecimal(totalAmount)}`}
                                                </Grid>
                                            </>
                                        )}
                                        <Grid item xs={1}>&nbsp;</Grid>
                                    </Grid>
                                }
                            />
                        </ListItem>
                    </List>
                    <Divider />
                    <Box
                        component="div"
                        sx={{
                            display: 'flex',
                            flexDirection: 'row-reverse',
                            margin: '1rem',
                            gap: '0.5rem',
                        }}
                    >
                        <Button
                            variant="contained"
                            color="primary"
                            startIcon={<PaymentsTwoToneIcon />}
                            onClick={() => payClicked()}
                            sx={classes.squashedButton}
                        >
                            Pay
                        </Button>
                        <Button
                            variant="outlined"
                            color="primary"
                            startIcon={<ReplayIcon />}
                            onClick={() => clearSelected()}
                            sx={classes.squashedButton}
                        >
                            Clear
                        </Button>
                        <Button
                            variant="outlined"
                            color="primary"
                            startIcon={<ArrowBackIosNewRoundedIcon />}
                            onClick={() => setShowSelected(false)}
                            sx={classes.squashedButton}
                        >
                            Back
                        </Button>
                    </Box>
                </Paper>
            )}
            {smallScreen && (
                <List sx={{ padding: 0 }}>
                    <Typography
                        variant='h6'
                        component='h3'
                        color='primary'
                        sx={{ fontSize: '1.2rem', marginTop: 1}}
                    >
                        Selected Fees
                    </Typography>
                    {fees && fees.map((fee) => (
                        <Card elevation={2} sx={{ margin: '1rem 0', padding: '1rem' }} key={fee.key}>
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
                                        {fee.name}
                                    </Typography>
                                    <IconButton
                                        size="small"
                                        onClick={() => removeSelected(fee.key)}
                                    >
                                        <DeleteTwoTone />
                                    </IconButton>
                                </Box>
                                <Divider />
                                <Grid container spacing={1}>
                                    <Grid item xs={6}>
                                        <Typography variant="body2" color="textSecondary">Cost:</Typography>
                                    </Grid>
                                    <Grid item xs={6} sx={{ textAlign: 'right' }}>
                                        <Typography variant="body2">${getDecimal(fee.itemAmount)}</Typography>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Typography variant="body2" color="textSecondary">Quantity:</Typography>
                                    </Grid>
                                    <Grid item xs={6} sx={{ textAlign: 'right' }}>
                                        <Typography variant="body2">{Math.floor(fee.quantity)}</Typography>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Divider />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Typography fontWeight="bold" variant="body2" color="black">Total:</Typography>
                                    </Grid>
                                    <Grid item xs={6} sx={{ textAlign: 'right' }}>
                                        <Typography fontWeight="bold" variant="body2">${getDecimal(fee.amount)}</Typography>
                                    </Grid>
                                </Grid>
                                {fee.comments && (
                                    <>
                                        <Divider />
                                        <Box sx={{ marginTop: '0.5rem' }}>
                                            <Typography variant="body2" color="black" sx={{ fontWeight: 'bold' }}>
                                                Comments
                                            </Typography>
                                            <Typography variant="body2">{fee.comments}</Typography>
                                        </Box>
                                    </>
                                )}
                            </Box>
                        </Card>
                    ))}
                    {selectedOption && (
                        <Card elevation={2} sx={{ margin: '1rem 0', padding: '1rem' }}>
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
                                        {selectedOption.name}
                                    </Typography>
                                </Box>
                                <Divider />
                                <Grid container spacing={1}>
                                    <Grid item xs={6}>
                                        <Typography variant="body2" color="textSecondary">Description:</Typography>
                                    </Grid>
                                    <Grid item xs={6} sx={{ textAlign: 'right' }}>
                                        <Typography variant="body2">{selectedOption.description}</Typography>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Typography variant="body2" color="textSecondary">Amount:</Typography>
                                    </Grid>
                                    <Grid item xs={6} sx={{ textAlign: 'right' }}>
                                        <Typography variant="body2">${getDecimal(selectedOption.amount)}</Typography>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Card>
                    )}
                    <Card elevation={2} sx={{ margin: '1rem 0', padding: '1rem' }}>
                        <Grid container spacing={1}>
                            <Grid item xs={6}>
                                <Typography variant="body2" color="black" sx={{ fontWeight: 'bold' }}>
                                    Fee Total:
                                </Typography>
                            </Grid>
                            <Grid item xs={6} sx={{ textAlign: 'right' }}>
                                <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                                    ${getDecimal(feeTotal)}
                                </Typography>
                            </Grid>
                            {splitFees ? (
                                <>
                                    <Grid item xs={12}>
                                        <Divider />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Typography variant="body2" color="textSecondary">
                                            We cannot determine the amount of the Processing Fee until you select a payment type. Depending upon the type of payment you select, you may be required to pay a Processing Fee to process the transaction.
                                        </Typography>
                                    </Grid>
                                </>
                            ) : (
                                <>
                                    <Grid item xs={6}>
                                        <Typography variant="body2" color="black" sx={{ fontWeight: 'bold' }}>
                                            Processing Fee:
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={6} sx={{ textAlign: 'right' }}>
                                        <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                                            ${getDecimal(processingFee)}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Typography variant="body2" color="black" sx={{ fontWeight: 'bold' }}>
                                            Total Amount:
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={6} sx={{ textAlign: 'right' }}>
                                        <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                                            ${getDecimal(totalAmount)}
                                        </Typography>
                                    </Grid>
                                </>
                            )}
                        </Grid>
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '10px',
                                marginTop: '1rem',
                            }}
                        >
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={payClicked}
                            >
                                Pay Fees
                            </Button>
                            <Button
                                variant="outlined"
                                color="primary"
                                onClick={clearSelected}
                            >
                                Clear All Fees
                            </Button>
                            <Button
                                variant="outlined"
                                color="primary"
                                onClick={() => setShowSelected(false)}
                            >
                                Back
                            </Button>
                        </Box>
                    </Card>
                </List>
            )}
        </>
    );
};

export default SelectedFees;